<div class="cursor-pointer px-3"
     [ngClass]="{'tk-i-left-arrow': !isHovered, 'tk-i-left-arrow-blue': isHovered}"
     (mouseover)="onHover(true)" (mouseout)="onHover(false)"
     (click)="onClick()"></div>
